<span *ngIf="cardBrand" class="icon-brands icon-brands-{{ cardBrand }}"></span>
